import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/results/:lsrid/:sectionName',
    name: 'Results',
    component: () => import(/* webpackChunkName: "review" */ '../views/Results.vue')
  },
  {
    path: '/review/',
    name: 'LSRIndex',
    component: () => import(/* webpackChunkName: "LSRIndex" */ '../views/LSRIndex.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
